import { useTranslation } from 'react-i18next';
import { Server, ArrowUpRight } from 'lucide-react';
import { SpecSheet } from './SpecSheet';
import { GithubIcon, LinkedinIcon } from './icons';

export const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 md:py-20 border-b border-gray-800/80">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">

        {/* Left Headline */}
        <div className="lg:col-span-8 space-y-6">
          <div className="inline-flex items-center space-x-2 text-xs font-mono tracking-widest text-[#00F0FF] border border-[#00F0FF]/30 bg-[#00F0FF]/5 px-3 py-1">
            <Server size={13} />
            <span>{t('hero.badge')}</span>
          </div>

          <h1 className="text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.05] text-white">
            {t('hero.titleLine1')}{' '}
            <span className="text-transparent bg-clip-text bg-linear-to-r from-[#00F0FF] via-cyan-200 to-white">
              {t('hero.titleHighlight')}
            </span>{' '}
            {t('hero.titleLine2')}
          </h1>

          {/* Action Links */}
          <div className="pt-2 flex flex-wrap items-center gap-4 font-mono text-sm">
            <a
              href="https://www.linkedin.com/in/luanyata/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center space-x-2 bg-[#00F0FF] text-[#07090E] font-bold px-5 py-3 hover:bg-cyan-300 transition-all shadow-[0_0_20px_rgba(0,240,255,0.25)]"
            >
              <LinkedinIcon size={16} />
              <span>{t('hero.btnLinkedin')}</span>
              <ArrowUpRight size={16} />
            </a>

            <a
              href="https://github.com/luanyata"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center space-x-2 border border-gray-700 hover:border-[#00F0FF] text-gray-300 hover:text-white px-5 py-3 transition-all bg-[#0A0D14]"
            >
              <GithubIcon size={16} />
              <span>{t('hero.btnGithub')}</span>
            </a>
          </div>
        </div>

        {/* Right Spec Sheet */}
        <div className="lg:col-span-4">
          <SpecSheet />
        </div>

      </div>
    </section>
  );
};
